import Mock from 'mockjs'

// 自动加载 modules 下面的模块
const modulesFiles = require.context('./modules', true, /\.js$/)

let mocksList = []
modulesFiles.keys().reduce((modules, modulePath) => {
    const value = modulesFiles(modulePath)
    
    mocksList.push(...value.default)
}, {})


// 修复在使用 MockJS 情况下，设置 withCredentials = true，且未被拦截的跨域请求丢失 Cookies 的问题
// https://github.com/nuysoft/Mock/issues/300
Mock.XHR.prototype.proxy_send = Mock.XHR.prototype.send
Mock.XHR.prototype.send = function () {
    if (this.custom.xhr) {
        this.custom.xhr.withCredentials = this.withCredentials || false
    }
    this.proxy_send(...arguments)
}


// mock 接口
for (let i of mocksList) {
    // Mock.mock(new RegExp(i.url), i.type || 'get', i.response)
}

export default Mock